import classNames from 'classnames';
import getLocal from '@/app/utils/getLocal';
import React, { useEffect, useRef, useState } from 'react';
import EfLink from '../ef-link';
import EfModal from '../ef-modal';
import CheckInCouponList from './CheckInCouponList';
import {
    autoCouponListWithGiftCard,
    checkUserGainReissue,
    gainReissueCount,
    getSignInIntegral,
    getSignInRecord,
    rewardSignInCampaignGet,
    rewardSignInCampaignGetLogin,
    rewardSignInCampaignSignIn,
    rewardUserInfoSelectByUserId,
} from './comps/apis';
import { langText } from './comps/langText';
import TextBtn from './comps/TextBtn';
import { getDateBeforeNDays, getDaysFromTwoDate, getItemFromItems, getTipsMessageHandle, scrollXToElement, setItemsIsLimit } from './comps/utils';
import CouponBtn from './CouponBtn';
import './index.scss';
import WinDeductPoints from './wins/WinDeductPoints';
import WinShare from './wins/WinShare';
import WinSureBefore from './wins/WinSureBefore';
import WinTipsSuccessA from './wins/WinTipsSuccessA';
import WinVisitPage from './wins/WinVisitPage';
import { getIsLogin } from '@/utils/cookie';
import gtm from '@/utils/gtm';
import { formatLocalTime } from '@/utils/timeConversionTool';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { useGlobal } from '@/utils/useGlobal';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { createPortal } from 'react-dom';
import LoginFormModal from '@/components/LoginFormModal';
import EfImg from '@elem/ui/ef-img';

const getTimeForAllBrowser = (value: string) => {
    if (!value) return '';
    if (typeof String.prototype.replaceAll === 'undefined') {
        return value.toString().replaceAll('-', '/');
    }
    return value.toString().replace(/\-/g, '/');
};
export interface EfCheckInActivitiesItemProps {
    /**
     * 当前月数
     */
    month: string;
    /**
     * 当前星期
     */
    week: string;
    /**
     * 当前日
     */
    day: string;
    /**
     * 是否是今天
     */
    today: 'today' | 'before' | 'after';
    /**
     * 可获得多少积分
     */
    score: number;
    /**
     * 已签到类型
     *
     * 1 正常签到
     *
     * 2 补签签到
     *
     * 没有值的是还没有打过卡的
     */
    signInType: 1 | 2;
    /**
     * 允许补卡
     */
    reissueSign?: boolean;
    /**
     * 是否限制打卡
     */
    isLimit?: boolean;
    /**
     * 年月日字符串 2024-11-20
     */
    dateString?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 素材
     */
    rewardByDayRespVos: Record<string, string>;
    signInPictureUrl: string;
    signInPictureShow: boolean;
}
interface EfCheckInActivitiesProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 自定义时间
     */
    systemTime?: number | null;
    /**
     * 活动URL
     */
    pageUrl?: string;
    /**
     * 获取打卡信息时回调
     */
    getMsgCallback?: (data: any) => void;
    /**
     * 签到成功回调
     */
    successCallback?: () => void;
    /**
     * 返空回调
     */
    callback?: () => void;
    /**
     * 配置化
     */
    data: any;
}

const defaultPointImg = 'https://websiteoss.ecoflow.com/figma-uploads/1764399732525-pn11f0-compressed-Frame%202094654356.png';
const defaultCouponImg = 'https://websiteoss.ecoflow.com/figma-uploads/1764399744816-glv82u-compressed-Frame%202094654384.png';
/**
 * 维护:谢保林
 *
 * 打卡活动
 */
const EfCheckInActivities: React.FC<EfCheckInActivitiesProps> = ({ pageUrl, className, getMsgCallback, successCallback, callback, data }) => {
    const prefixCls = `ef-check-in-activities2`;
    const { locale, pathname } = getLocal();
    const {
        loginType = 'page',
        cardBgColor,
        bgPCImg,
        bgh5Img,
        titleColor,
        subTitleColor,
        tipsColor,
        clockInWordColor,
        awardTipColor,
        btnBeforeText,
        btnAfterText,
        btnExpiredText,
        btnBeforeColor,
        btnAfterColor,
        btnExpiredColor,
        cardBeforeColor,
        cardBeforeBgColor,
        cardBeforeBgImg,
        cardAfterColor,
        cardAfterBgColor,
        cardAfterBgImg,
        cardExpiredColor,
        cardExpiredBgColor,
        cardExpiredBgImg,
        dateColor,
        linkMoreColor,
        linkMoreName,
        linkMoreUrl,
    } = data;

    const TextA = langText[locale] || langText['us'];
    const { isMobile } = useGlobal();
    const styleComp: any = {
        '--member-h-titleColor': titleColor,
        '--member-h-dateColor': dateColor,
        '--member-h-subTitleColor': subTitleColor,
        '--member-h-tipsColor': tipsColor,
        '--member-h-clockInWordColor': clockInWordColor,
        '--member-h-awardTipColor': awardTipColor,
        '--member-h-linkMoreColor': linkMoreColor,
    };
    const backgroundStyle: React.CSSProperties = (() => {
        const img = isMobile ? bgh5Img : bgPCImg;
        if (img) {
            return {
                backgroundImage: `url(${img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            };
        }
        if (cardBgColor) {
            return { backgroundColor: cardBgColor };
        }
        return { backgroundColor: '#f5f5f5' };
    })();
    const [activeData, setActiveData] = useState<any>({}); // 打卡活动信息
    const activeDataRef = useRef<any>({});
    const [userData, setUserData] = useState<any>({}); // 用户打卡活动信息
    const [isLogin, setIsLogin] = useState(false); // 是否已登录
    const [itemsA, setItemsA] = useState<any[]>([]); // 打卡列表
    const itemsARef = useRef<any[]>([]); // 打卡列表
    const campaignStatus = `${activeData.campaignStatus || 0}`; //活动状态
    const [loginHref, setLoginHref] = useState<string | undefined>(`/${locale}/login?redirect=/${locale}${pathname}`);
    const axiosLoading = useRef<boolean>(false); //用于防重点击
    const [isDisabledAll, setIsDisabledAll] = useState(false); // 是否没到签到时间
    const [todayIsSuccess, setTodayIsSuccess] = useState(false); // 点击今天后,设置已打卡
    const dailySignInPoints = `${activeData.dailySignInPoints}`;
    const [beforeWinType, setBeforeWinType] = useState(''); //补签方式-弹窗类型
    const [checkReadyDay, setCheckReadyDay] = useState(0);
    const pageUrlRef = useRef(pageUrl || '');
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-no-login`]: !isLogin,
        [`${prefixCls}-dailySignInPoints-${dailySignInPoints}`]: dailySignInPoints,
        [`${prefixCls}-disabled`]: isDisabledAll,
        [`${prefixCls}-disabled-today`]: todayIsSuccess,
        [`${prefixCls}-rewardType-${activeData.rewardType}`]: activeData.rewardType,
    });
    const defaultPrizeImg = activeData.rewardType === 1 ? defaultPointImg : defaultCouponImg;
    const activeIsExpired = activeData.campaignStatus !== 1; //活动是否过期
    const [currentCheckData, setCurrentCheckData] = useState<any>({}); //手机端,当前打卡信息
    const [listCouponB, setListCouponB] = useState<any[]>([]);
    // 细则
    const [isOpen2, setIsOpen2] = useState(false);
    // 提示语
    const dialogTimer = useRef<any>(null);
    const [isOpen1, setIsOpen1] = useState(false);
    const [dialogTips, setDialogTips] = useState('');
    // 打卡成功,获得优惠券
    const [couponData, setCouponData] = useState({
        coupon: '',
        couponName: '',
        shoppingUrl: '',
    });
    const [mixEcocredits, setMixEcocredits] = useState<number | undefined>(undefined);
    // const { timezoneList } = useMemberTimeStore();
    // const { getSystemTime } = useGlobal();
    const getButtonStatus = (item: EfCheckInActivitiesItemProps) => {
        // 签到前 1 签到后 2  已过期 3
        if ((item?.signInType as any) === 1 || (item?.signInType as any) === 2) return 2;
        if (item?.today === 'before' && !item?.signInType && (!activeData?.reissueSign || activeIsExpired)) return 3;
        return 1;
    };

    const getButtonName = (item: EfCheckInActivitiesItemProps) => {
        const status = getButtonStatus(item);
        if (status === 1 && btnBeforeText) return btnBeforeText;
        if (status === 2 && btnAfterText) return btnAfterText;
        if (status === 3 && btnExpiredText) return btnExpiredText;
        return '';
    };

    const setBBtnColor = (item: EfCheckInActivitiesItemProps) => {
        const status = getButtonStatus(item);

        if (status === 1 && btnBeforeColor)
            return {
                color: btnBeforeColor,
            };

        if (status === 2 && btnAfterColor)
            return {
                color: btnAfterColor,
            };

        if (status === 3 && btnExpiredColor)
            return {
                color: btnExpiredColor,
            };

        return {};
    };

    const setBgColor = (item: EfCheckInActivitiesItemProps) => {
        const status = getButtonStatus(item);

        if (status === 1 && cardBeforeColor === 'img')
            return { backgroundImage: `url(${cardBeforeBgImg}), backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'` };

        if (status === 1 && cardBeforeColor === 'color')
            return {
                background: cardBeforeBgColor,
            };

        if (status === 2 && cardAfterColor === 'img')
            return { backgroundImage: `url(${cardAfterBgImg}), backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'` };

        if (status === 2 && cardBeforeColor === 'color')
            return {
                background: cardAfterBgColor,
            };

        if (status === 3 && cardExpiredColor === 'img')
            return { backgroundImage: `url(${cardExpiredBgImg}), backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'` };

        if (status === 3 && cardExpiredColor === 'color')
            return {
                background: cardExpiredBgColor,
            };
        return {};
    };

    // 根据item设置已签到
    const setSignInTypeForClick = (item: EfCheckInActivitiesItemProps) => {
        const itemsB = JSON.parse(JSON.stringify(itemsARef.current));
        for (let i = 0; i < itemsB.length; i++) {
            const itemA = itemsB[i];
            if (itemA.dateString !== item.dateString) {
                continue;
            }
            if (itemA.today === 'before') {
                itemA.signInType = 2;
            } else {
                itemA.signInType = 1;
            }
        }
        setItemsA(itemsB);
        itemsARef.current = itemsB;
    };

    // 发起签到
    const sendAxiosCallback = async (data: any, item: any, options?: any) => {
        const signInCampaignId = activeDataRef.current.id;
        const isLogin2 = options?.isLogin || isLogin;
        const notGtm = options?.notGtm;
        if (isLogin2 && signInCampaignId) {
            if (axiosLoading.current) {
                return false;
            }
            axiosLoading.current = true; // 防重点击
            const res1 = await rewardSignInCampaignSignIn(locale, {
                signInCampaignId: signInCampaignId,
                ...data,
                //signInType: 1, //1,正常签到;2,补签;activeData.campaignType,
            });
            setTimeout(() => {
                axiosLoading.current = false; //防重点击
            }, 1500);
            const code1 = res1.code;

            const tipsA = getTipsMessageHandle(res1, TextA, locale);

            openTipsCallback(tipsA);
            if (code1 === '0') {
                if (!notGtm) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'check_in_success',
                        position: `${item.month}/${item.day}`,
                        button_name: TextA.btnMsgToday,
                        list_name: activeData.campaignName,
                    });
                }

                const dataRes = res1?.data || {};
                // 打卡成功-优惠券
                if (!dataRes.gainCouponRemainDay && dataRes.signedIn && dataRes.couponName && dataRes.coupon) {
                    const coupons = dataRes.coupon.split(',');
                    const couponNames = dataRes.couponName.split(',');
                    setCouponData({
                        coupon: coupons,
                        couponName: couponNames,
                        shoppingUrl: dataRes.shoppingUrl,
                    });
                    let coreNumber = 0;

                    const { durationSignInDay, durationSignInPoints, anySignInDay, anySignInPoints, isReissue, normalSignInPoints } = dataRes;
                    if (durationSignInDay > 0 && durationSignInPoints > 0) {
                        coreNumber = durationSignInPoints;
                    }

                    if (anySignInDay > 0 && anySignInPoints > 0) {
                        coreNumber = anySignInPoints;
                    }

                    if ((isReissue && normalSignInPoints > 0) || (!isReissue && normalSignInPoints > 0)) {
                        coreNumber = normalSignInPoints;
                    }

                    setMixEcocredits(coreNumber);
                    setBeforeWinType('WinTipsSuccessA');
                }

                if (dataRes.signedIn) {
                    // 打卡成功
                    const totalCount2 = (activeDataRef.current.totalCount || 0) + 1;
                    setCheckReadyDay(totalCount2);
                    setSignInTypeForClick(item);
                    getSignInIntegralFn(activeDataRef.current.id); // 刷新积分
                    if (currentCheckData.today === 'today') {
                        setCurrentCheckData({
                            ...currentCheckData,
                            signInType: 1,
                        });
                    }
                }
            }
            successCallback?.();
        }
    };

    // 初始化组件
    const autoCouponListWithGiftCardHandle = async () => {
        const res = await autoCouponListWithGiftCard(locale);
        if (res?.code === '0') {
            const list1 = res?.data || [];
            list1.sort((item1: any, item2: any) => {
                const redeemCount1 = Number(item1.redeemCount) || 0;
                const redeemCount2 = Number(item2.redeemCount) || 0;
                return redeemCount2 - redeemCount1;
            });
            const list2 = list1.slice(0, 3);
            const dataB = list2.map((item: any) => {
                const ruleWebsite = item.ruleWebsite || {};
                return {
                    ...item,
                    currencySymbol: ruleWebsite.currencySymbol,
                    amount: ruleWebsite.amount,
                    points: Number(item.points) || 0,
                };
            });
            setListCouponB(dataB);
        }
    };
    // 补签 gtm
    const gtmBeforeWinHandle = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Make up for check-in',
                list_name: activeData.campaignName,
                button_name: TextA.btnMsgReissueSign,
            });
        } catch (error) {}
    };
    // 点击签到
    const clickItemHandle = (item: any) => {
        if (loginHref) {
            return;
        }
        const sendData: any = {};
        if (item) {
            const today = item.today;
            const signInType = item.signInType;
            const isLimit = item.isLimit;
            if (today === 'before' && activeData.reissueSign && !isLimit) {
                //if (today === 'before') {
                // 补签的情况
                if (gainType === 1) {
                    //无
                    openBeforeWinHandle('WinSureBefore');
                    gtmBeforeWinHandle();
                } else if (gainType === 2) {
                    //浏览页面链接
                    openBeforeWinHandle('WinVisitPage');
                    gtmBeforeWinHandle();
                } else if (gainType === 3) {
                    const pointsNum1 = userPointRef.current.points || '0';
                    const pointsNum2 = Number(pointsNum1);
                    const gainConfig2 = Number(gainConfig);
                    if (!pointsNum2 || pointsNum2 < gainConfig2) {
                        return openTipsCallback(TextA.pointTipsB1);
                    }
                    //扣积分
                    openBeforeWinHandle('WinDeductPoints');
                    gtmBeforeWinHandle();
                } else if (gainType === 4) {
                    //分享他人
                    openBeforeWinHandle('WinShare');
                    gtmBeforeWinHandle();
                } else if (userData.remainderEnableReissueCount) {
                    //有打卡次数
                    sendAxiosCallback(
                        {
                            reissueDate: item.dateString,
                            signInType: 2, // 补签
                        },
                        item,
                    );
                    return;
                } else if (!gainTypeData.enable && gainTypeData.isOverLimit) {
                    // 不允许补卡--最大次数
                    openTipsCallback(TextA.code2455);
                    return;
                } else if (!gainTypeData.enable && !gainTypeData.isOverLimit) {
                    // 不允许补卡-24小时
                    openTipsCallback(TextA.errorCheckTips);
                    return;
                }
                setCurrentCheckData({
                    ...item,
                    //signInType: 2, // 补签
                });
                return; //补签不能走之前的逻辑了
            } else if (today === 'today' && ![1, 2].includes(signInType) && !isLimit) {
                // 今天
                sendData['signInType'] = 1;
                setTodayIsSuccess(true);
                setCurrentCheckData({
                    ...currentCheckData,
                    //signInType: 1,// 正常签一
                });
            } else if (today === 'after') {
                // TextA;
                openTipsCallback(TextA.errorTime);
            }
        }
        if (JSON.stringify(sendData) !== '{}') {
            sendAxiosCallback(sendData, item);
        }
    };

    // 打开细则
    const openDetailHandle = () => {
        setIsOpen2(true);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'Check-in Rules Popup',
                list_name: activeData.campaignName,
                button_name: TextA.noLoginTipsLink2,
            });
        } catch (error) {}
    };

    // 关闭细则
    const closeDetailHandle = () => {
        setIsOpen2(false);
    };

    // 打开补签弹窗
    const openBeforeWinHandle = (beforeWin: string) => {
        setBeforeWinType(beforeWin);
    };
    // 关闭补签弹窗
    const closeBeforeWinHandle = (isSure: boolean) => {
        setBeforeWinType('');
    };

    // 记录当前滚动位置，登录后滚回来
    const saveScrollPosition = () => sessionStorage.setItem('scrollPosition', String(document.documentElement.scrollTop));

    // 打开弹窗
    const openTipsCallback = (tips: string) => {
        setIsOpen1(true);
        setDialogTips(tips);
        dialogTimer.current = setTimeout(() => {
            closeTipsCallback();
        }, 5000);
    };

    // 关闭弹窗
    const closeTipsCallback = () => {
        setIsOpen1(false);
        setDialogTips('');
    };

    // 获取用户积分
    const userPointRef = useRef({
        points: 0,
    });
    const rewardUserInfoSelectByUserIdHandle = async () => {
        const res1 = await rewardUserInfoSelectByUserId(locale);
        if (res1.code === '0') {
            userPointRef.current = res1?.data || {};
        }
    };

    // 判断并设置是否不在打卡时间内
    const setTimeIfNotIn = (data1: any, systemTime: any) => {
        const { campaignStartTime, campaignEndTime } = data1;
        if (campaignStartTime && campaignEndTime) {
            const date1 = new Date(getTimeForAllBrowser(campaignStartTime));
            const date2 = new Date(getTimeForAllBrowser(campaignEndTime));
            const date3 = new Date(getTimeForAllBrowser(systemTime) || Date.now());
            if (date3 < date1 || date3 > date2) {
                // setIsDisabledAll(true); //不在打卡时间内
            }
        }
    };

    // 获取登录用户打卡情况
    const getSignInRecordFn = async (signInCampaignId: string, data1: any, systemTimeServer: any, callback?: any) => {
        const res1 = await getSignInRecord(locale, signInCampaignId);
        if (res1.code === '0') {
            const items1 = res1.data || [];
            const items2 = getItemsHandle2(data1, items1, systemTimeServer);
            callback && callback(items2);
            setActiveData(data1);
            activeDataRef.current = data1;
        }
    };

    // 获取用户打卡活动积分
    const getSignInIntegralFn = async (signInCampaignId: string) => {
        if (!signInCampaignId) {
            return;
        }
        const res1 = await getSignInIntegral(locale, signInCampaignId);
        if (res1.code === '0') {
            const dataA = res1.data || {};
            setUserData(dataA);
            setCheckReadyDay(dataA.totalSignInCount || 0);

            const list1 = dataA.couponList || [];

            setListCouponA(list1);
        }
    };
    // 滚动容器到今天
    const scrollXToElementHandle = () => {
        setTimeout(() => {
            scrollXToElement(
                document.querySelector('.ef-check-in-activities .ef-check-in-activities-items'),
                document.querySelector('.ef-check-in-activities .ef-check-in-activities-item-today'),
            );
        }, 500);
    };
    // 生成打卡列表-未登录
    const getItemsHandle1 = (data1: any, systemTimeDate: any) => {
        const { campaignStartTime, campaignEndTime } = data1;
        const startDate = campaignStartTime ? new Date(`${campaignStartTime}`) : getDateBeforeNDays(-5); //开始时间
        const endDate = campaignEndTime ? new Date(`${campaignEndTime}`) : getDateBeforeNDays(5); //结束时间
        const items2 = setItemsIsLimit(getDaysFromTwoDate(startDate, endDate, systemTimeDate), data1);
        setActiveData(data1);
        activeDataRef.current = data1;
        setItemsA(items2);
        itemsARef.current = items2;
        scrollXToElementHandle();
    };

    // 生成打卡列表-已登录
    const getItemsHandle2 = (data1: any, items1: any, systemTimeDate: any) => {
        const { campaignStartTime, campaignEndTime } = data1;
        const startDate = campaignStartTime ? new Date(`${getTimeForAllBrowser(campaignStartTime)}`) : getDateBeforeNDays(-5); //开始时间
        const endDate = campaignEndTime ? new Date(`${getTimeForAllBrowser(campaignEndTime)}`) : getDateBeforeNDays(5); //结束时间
        const items2 = setItemsIsLimit(getDaysFromTwoDate(startDate, endDate, systemTimeDate), data1);

        items2.forEach((item1: any) => {
            // 查询是否已打卡
            const findIndex = items1.findIndex((item2: any) => {
                return item2.signInDate === item1.dateString;
            });

            if (findIndex > -1) {
                const item3 = items1[findIndex];
                item1.signInType = item3.signInType; //已签到类型
            }
        });
        const curItem = getItemFromItems(items2, 'today');
        setCurrentCheckData(curItem);
        setItemsA(items2);
        itemsARef.current = items2;
        scrollXToElementHandle();
        return JSON.parse(JSON.stringify(items2));
    };

    // 获取站点打卡活动信息
    const rewardSignInCampaignGetFn = async (isLogin: boolean) => {
        const pathname1 = pageUrlRef.current;
        const pathname2 = pathname1 || `/${locale}${pathname}`;

        let res1: any = {};
        if (isLogin) {
            res1 = await rewardSignInCampaignGetLogin(locale, pathname2);
        } else {
            res1 = await rewardSignInCampaignGet(locale, pathname2);
        }
        if (res1?.code === '0') {
            const data1 = res1.data || {};
            const systemTimeServer = getTimeForAllBrowser(data1.localCurrentTime) || new Date();
            // const systemTimeServer = formatLocalTime(getSystemTime(), timezoneList);
            setTimeIfNotIn(data1, systemTimeServer);
            const signInCampaignId = data1.id;

            if (signInCampaignId && isLogin) {
                //已登录,查询个人打卡信息
                getSignInRecordFn(signInCampaignId, data1, systemTimeServer, (items2: any) => {
                    setTimeout(() => {
                        initOverDownCheck(
                            {
                                signInCampaignId,
                            },
                            items2,
                        );
                    }, 1000);
                });
                getSignInIntegralFn(signInCampaignId);
                getCheckUserGainReissue(signInCampaignId); // 刷新是否可以重新补卡
                rewardUserInfoSelectByUserIdHandle(); //获取用户积分
            } else if (signInCampaignId) {
                // 未登录,直接生成
                getItemsHandle1(data1, systemTimeServer);
            }
            if (data1.redeemSkip && data1.redeemSkipUrl) {
                autoCouponListWithGiftCardHandle();
            }
            getMsgCallback?.(data1); //将打卡信息回传到父组件
        }
    };
    // 补卡类型
    const [enable, setEnable] = useState(false); // 是否允许补卡
    const [gainType, setGainType] = useState<number | null>(null);
    const [gainConfig, setGainConfig] = useState<any>(null);
    const [gainTypeData, setGainConfigData] = useState<any>({});
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);

    // 判断登录用户能否新增补卡次数
    const getCheckUserGainReissue = async (signInCampaignId: string) => {
        const res = await checkUserGainReissue(locale, signInCampaignId);
        if (res?.code === '0') {
            const data = res?.data || {};
            setGainType(data.gainType);
            setGainConfig(data.gainConfig);
            setEnable(data.enable);
            setGainConfigData(data);
        }
    };

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsClient(true);
        setIsLogin(isLogin2);
        if (isLogin2) {
            setLoginHref(undefined);
        } else {
            setLoginHref(`/${locale}/login?redirect=${encodeURIComponent(location.href)}`);
        }
        rewardSignInCampaignGetFn(isLogin2);
    }, []);

    // 页面浏览完成,执行打卡;是否进行打卡
    const initOverDownCheck = (options: any, items2: any) => {
        const urlA = new URL(location.href);
        const searchA = urlA.searchParams;
        const overDownA = searchA.get('overDown');
        const dateString = searchA.get('date');
        // 浏览
        if (overDownA === 'check-in' && dateString) {
            let itemSelect = null;
            for (let i = 0; i < items2.length; i++) {
                const itemA = items2[i];
                if (itemA.dateString === dateString) {
                    itemSelect = itemA;
                }
            }

            sendAxiosCallback(
                {
                    signInType: 2,
                    reissueDate: dateString,
                },
                {
                    ...itemSelect,
                },
                {
                    signInCampaignId: options.signInCampaignId,
                    isLogin: true,
                    isAutoCheck: true,
                },
            );
        }
    };

    // 补签-确定-分享页面
    const WinWinShareOkHandle = async (type: string, href: string, closeFlag?: boolean) => {
        if (!enable) {
            return;
        }
        const res = await gainReissueCount(locale, {
            signInCampaignId: activeData.id,
            gainConfig: href,
            gainType: 4,
        });
        if (res?.code === '0') {
            // openTipsCallback(res?.message);
            const signInType = currentCheckData.signInType; // signInType 没有值是未打卡
            if (!signInType && typeof gainConfig === 'string') {
                const gainConfig2 = JSON.parse(gainConfig);
                delete gainConfig2[type];
                setGainConfig(JSON.stringify(gainConfig2));
                await sendAxiosCallback(
                    {
                        reissueDate: currentCheckData.dateString,
                        signInType: 2,
                    },
                    currentCheckData,
                );
                await getCheckUserGainReissue(activeData.id); // 刷新是否可以重新补卡
            }
            getSignInIntegralFn(activeData.id); // 刷新积分
        }
        setBeforeWinType('');
    };
    // 补签-确定-扣积分
    const WinDeductPointsOkHandle = async () => {
        const res = await gainReissueCount(locale, {
            signInCampaignId: activeData.id,
            gainType: 3,
        });
        if (res?.code === '0') {
            sendAxiosCallback(
                {
                    reissueDate: currentCheckData.dateString,
                    signInType: 2,
                },
                currentCheckData,
                {
                    notGtm: true,
                },
            );
            setBeforeWinType('');
            getCheckUserGainReissue(activeData.id); // 刷新是否可以重新补卡
            getSignInIntegralFn(activeData.id); // 刷新积分
        }
    };
    // 补签-确定-直接(1|无)
    const WinSureBeforeOkHandle = async () => {
        let remainderEnableReissueCount = userData.remainderEnableReissueCount;
        if (!remainderEnableReissueCount && enable) {
            // 没有补卡次数,先补签
            const res = await gainReissueCount(locale, {
                signInCampaignId: activeData.id,
                gainType: 1,
            });
            if (res?.code === '0') {
                remainderEnableReissueCount = 1;
            }
        }
        if (remainderEnableReissueCount > 0) {
            sendAxiosCallback(
                {
                    reissueDate: currentCheckData.dateString,
                    signInType: 2,
                },
                currentCheckData,
                {
                    notGtm: true,
                },
            );

            setBeforeWinType('');
            await getCheckUserGainReissue(activeData.id); // 刷新是否可以重新补卡
            await getSignInIntegralFn(activeData.id); // 刷新积分
        }
    };

    const [listCouponA, setListCouponA] = useState<any[]>([]);

    if (isDisabledAll) {
        callback?.();
        return <></>;
    }

    if (campaignStatus === '1') {
        return (
            <div className={classes} style={backgroundStyle}>
                <div className="ef-container" style={styleComp}>
                    <div className={`${prefixCls}-title`}>{activeData.campaignName}</div>
                    {activeData.campaignAbout && (
                        <div
                            className={`${prefixCls}-desc`}
                            dangerouslySetInnerHTML={{
                                __html: activeData.campaignAbout,
                            }}
                        ></div>
                    )}
                    {!isLogin && (
                        <div className={`${prefixCls}-no-login-msg`}>
                            {TextA.noLoginTips1}
                            <EfLink
                                className={`${prefixCls}-weight`}
                                // href={loginHref}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'ecocredits_button',
                                    type: 'Login',
                                    list_name: activeData.campaignName,
                                    button_name: TextA.noLoginTipsLink1,
                                }}
                                onClick={() => {
                                    saveScrollPosition();
                                    if (loginHref) {
                                        signupCookie({
                                            sector_name: activeData.campaignName,
                                            entry_position: 0,
                                        });
                                    }
                                    if (loginType === 'page') {
                                        if (loginHref) {
                                            window.location.href = loginHref;
                                        }
                                    } else if (loginType === 'modal') {
                                        setShowLoginModal(true);
                                    }
                                }}
                            >
                                {TextA.noLoginTipsLink1}
                            </EfLink>
                            {TextA.noLoginTips2}
                            {activeData.campaignDetail && (
                                <span className={`${prefixCls}-weight daka-tips`} onClick={openDetailHandle}>
                                    {TextA.noLoginTipsLink2}
                                </span>
                            )}
                        </div>
                    )}
                    {isLogin && (
                        <div className={`${prefixCls}-login`}>
                            <div className={`${prefixCls}-login-ready-day`}>
                                {TextA.hasCheckDayTips1}
                                <span className={`${prefixCls}-login-ready-day-num`}>{checkReadyDay}</span>
                                {TextA.hasCheckDayTips2}
                            </div>
                            {activeData.rewardType === 1 && (
                                <>
                                    {TextA.loginScore1}
                                    <span className={`${prefixCls}-weight ${prefixCls}-color-red`}>{userData.totalPoints || 0}</span>
                                </>
                            )}
                            {activeData.campaignDetail && (
                                <span className={`${prefixCls}-weight daka-tips`} onClick={openDetailHandle}>
                                    {TextA.noLoginTipsLink2}
                                </span>
                            )}
                            {(activeData.rewardType === 2 || activeData.rewardType === 3) && (
                                <CouponBtn prefixCls={prefixCls} TextA={TextA} listCouponA={listCouponA} activeData={activeData} />
                            )}
                        </div>
                    )}
                    <div className={`${prefixCls}-in`}>
                        <div className={`${prefixCls}-items`}>
                            {itemsA.map((item: EfCheckInActivitiesItemProps, index: number) => {
                                if (item.isLimit) {
                                    return null;
                                }
                                const itemClass = classNames(`${prefixCls}-item ${prefixCls}-item-${item.today}`, {
                                    [`${prefixCls}-item-signInType${item.signInType}`]: item.signInType,
                                    [`${prefixCls}-item-reissueSign`]: item.reissueSign,
                                    [`${prefixCls}-item-limit`]: item.isLimit,
                                    [`${prefixCls}-item-enable`]: !enable && item.today === 'before',
                                    [`${item.className}`]: item.className,
                                });
                                return (
                                    <div className={itemClass} key={index}>
                                        <div className={`${prefixCls}-item-intro`} style={setBgColor(item)}>
                                            {item.signInType === 1 || item.signInType === 2 || (item.today === 'before' && !item.reissueSign) ? (
                                                <EfImg
                                                    className={`${
                                                        [2, 3].includes(getButtonStatus(item)) && item?.rewardByDayRespVos?.rewardType !== 2
                                                            ? 'img-size-small'
                                                            : ''
                                                    }`}
                                                    pc={item?.rewardByDayRespVos?.rewardPictureUrl || defaultPrizeImg}
                                                    h5={item?.rewardByDayRespVos?.rewardPictureUrl || defaultPrizeImg}
                                                />
                                            ) : (
                                                <EfImg
                                                    pc={
                                                        item?.signInPictureUrl ||
                                                        item?.rewardByDayRespVos?.signInPictureUrl ||
                                                        item?.rewardByDayRespVos?.rewardPictureUrl
                                                    }
                                                    h5={
                                                        item?.signInPictureUrl ||
                                                        item?.rewardByDayRespVos?.signInPictureUrl ||
                                                        item?.rewardByDayRespVos?.rewardPictureUrl
                                                    }
                                                />
                                            )}
                                            <div className={`${prefixCls}-item-date-number`}>{item.day}</div>
                                            {/* <div className={`${prefixCls}-item-img`}></div> */}
                                            {/* <div className={`${prefixCls}-item-num`}>{activeData.dailySignInPoints}</div> */}
                                            {activeData.rewardType === 1 && (
                                                <div className={`${prefixCls}-item-msg`}>
                                                    {activeData.dailySignInPoints} {TextA.scoreMs}
                                                </div>
                                            )}
                                            {activeData.rewardType === 3 &&
                                                [2, 3].includes(getButtonStatus(item)) &&
                                                !!item.rewardByDayRespVos.points &&
                                                Number(item.rewardByDayRespVos.points) > 0 && (
                                                    <div className={`${prefixCls}-item-msg1`}>
                                                        {item.rewardByDayRespVos.points} {TextA.scoreMs}
                                                    </div>
                                                )}
                                            {!isLogin && loginType === 'modal' ? (
                                                <EfLink
                                                    className={`${prefixCls}-item-btn`}
                                                    dataLayer={{
                                                        event: 'uaEvent',
                                                        event_name: 'activity_join_login',
                                                        button_name: TextA.btnMsgToday,
                                                    }}
                                                    onClick={() => {
                                                        setShowLoginModal(true);
                                                    }}
                                                    style={setBBtnColor(item)}
                                                >
                                                    {getButtonName(item) ?? <TextBtn item={item} TextA={TextA} />}
                                                </EfLink>
                                            ) : (
                                                <EfLink
                                                    href={loginHref}
                                                    className={`${prefixCls}-item-btn`}
                                                    dataLayer={{
                                                        event: 'uaEvent',
                                                        event_name: 'activity_join_login',
                                                        button_name: TextA.btnMsgToday,
                                                    }}
                                                    onClick={() => {
                                                        clickItemHandle(item);
                                                    }}
                                                    style={setBBtnColor(item)}
                                                >
                                                    {getButtonName(item) ?? <TextBtn item={item} TextA={TextA} />}
                                                </EfLink>
                                            )}
                                        </div>
                                        {/* <div className={`${prefixCls}-item-border`}>
                                        <div className={`${prefixCls}-item-border-in`}></div>
                                    </div> */}
                                        <div className={`${prefixCls}-item-day`}>
                                            <div className={`${prefixCls}-item-day-in`}>
                                                {item.today == 'today' ? TextA.today : `${item.month}/${item.day}`}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={`${prefixCls}-btn-box`}>
                            {!isLogin && loginType === 'modal' ? (
                                <EfLink
                                    href={loginHref}
                                    className={`${prefixCls}-btn ${prefixCls}-item-signInType${currentCheckData?.signInType}`}
                                    onClick={() => setShowLoginModal(true)}
                                    dataLayer={isLogin ? null : { event: 'uaEvent', event_name: 'activity_join_login', button_name: TextA.btnMsgToday }}
                                >
                                    {TextA.btnMsgToday}
                                </EfLink>
                            ) : (
                                <EfLink
                                    href={loginHref}
                                    className={`${prefixCls}-btn ${prefixCls}-item-signInType${currentCheckData?.signInType}`}
                                    onClick={() => {
                                        //saveScrollPosition();
                                        clickItemHandle(currentCheckData);
                                    }}
                                    dataLayer={isLogin ? null : { event: 'uaEvent', event_name: 'activity_join_login', button_name: TextA.btnMsgToday }}
                                >
                                    {isLogin ? getButtonName(currentCheckData) ?? <TextBtn item={currentCheckData} TextA={TextA} /> : TextA.btnMsgToday}
                                </EfLink>
                            )}
                        </div>

                        {isOpen1 && dialogTips && (
                            <div className={`${prefixCls}-tips-dialog`}>
                                <div className={`${prefixCls}-tips-dialog-in`}>{dialogTips}</div>
                            </div>
                        )}
                        {isOpen2 && (
                            <EfModal open={isOpen2} callback={closeDetailHandle} className={`ef-check-in-dialog ${prefixCls}-campaignDetail`}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: activeData.campaignDetail,
                                    }}
                                ></div>
                                <div className={`${prefixCls}-footer`}>
                                    <button className="ef-check-in-dialog-btn" onClick={closeDetailHandle}>
                                        {TextA.Close}
                                    </button>
                                </div>
                            </EfModal>
                        )}
                    </div>
                    {beforeWinType === 'WinShare' && <WinShare callback={closeBeforeWinHandle} gainConfig={gainConfig} okCallback={WinWinShareOkHandle} />}
                    {beforeWinType === 'WinVisitPage' && (
                        <WinVisitPage callback={closeBeforeWinHandle} gainConfig={gainConfig} signInCampaignId={activeData.id} item={currentCheckData} />
                    )}
                    {beforeWinType === 'WinDeductPoints' && (
                        <WinDeductPoints
                            callback={closeBeforeWinHandle}
                            okCallback={WinDeductPointsOkHandle}
                            gainConfig={gainConfig}
                            currentCheckData={currentCheckData}
                            activeData={activeData}
                        />
                    )}
                    {beforeWinType === 'WinSureBefore' && <WinSureBefore callback={closeBeforeWinHandle} okCallback={WinSureBeforeOkHandle} />}
                    {activeData.redeemSkip && activeData.redeemSkipUrl && !!listCouponB.length && (
                        <CheckInCouponList redeemSkipUrl={activeData.redeemSkipUrl} listCouponB={listCouponB} />
                    )}

                    {beforeWinType === 'WinTipsSuccessA' && (
                        <WinTipsSuccessA TextA={TextA} callback={closeBeforeWinHandle} couponData={couponData} mixEcocredits={mixEcocredits} />
                    )}
                    {linkMoreName && (
                        <EfLink href={linkMoreUrl || '#'} className={`${prefixCls}-item-bottom-link`}>
                            {linkMoreName}
                        </EfLink>
                    )}
                </div>
                {isClient &&
                    showLoginModal &&
                    createPortal(
                        <LoginFormModal
                            visible={showLoginModal}
                            onCancel={() => {
                                setShowLoginModal(false);
                            }}
                            type="passwordless"
                        />,
                        document.body,
                    )}
            </div>
        );
    }

    return <div className={`${prefixCls}-empty`}></div>;
};

export default EfCheckInActivities;
